import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {SocketService} from "../../_services/socket.service";
import {User} from "../../_types/user";
import {AuthService} from "../../_services/auth.service";

interface TypingUser {
    userId: string;
    username: string;
}

@Component({
    selector: 'app-typing-indicator',
    templateUrl: './typing-indicator.component.html',
    styleUrl: './typing-indicator.component.scss'
})
export class TypingIndicatorComponent implements OnInit, OnDestroy {
    @Input({required: true}) postId!: number;
    typingUsers: Array<{ userId: string; username: string }> = [];
    private subscription: Subscription | undefined;
    currentUser: User | undefined

    constructor(private socketService: SocketService,
                private authService: AuthService) {
    }

    ngOnInit(): void {
        // Join the post's room to receive updates
        this.socketService.joinPost(this.postId);
        this.currentUser = this.authService.getUser();

        // Subscribe to typing updates
        this.subscription = this.socketService
            .getTypingUsers(this.postId)
            .subscribe(users => {
                this.typingUsers = this.filterUniqueById(users);
                if (this.currentUser) {
                    const i: number = this.typingUsers.findIndex((x: any): boolean => Number(x.userId) === this.currentUser?.id);
                    if (i != null && i >= 0) {
                        this.typingUsers.splice(i, 1);
                    }
                }
            });
    }

    filterUniqueById(arr: TypingUser[]): TypingUser[] {
        const seenIds = new Set();
        const uniqueArray = [];
        for (const item of arr) {
            if (!seenIds.has(item['userId'])) {
                seenIds.add(item['userId']);
                uniqueArray.push(item);
            }
        }
        return uniqueArray;
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    getTypingMessage(): string {
        if (this.typingUsers.length === 0) return '';
        if (this.typingUsers.length === 1) {
            return `${this.typingUsers[0].username} is typing...`;
        }
        if (this.typingUsers.length === 2) {
            return `${this.typingUsers[0].username} and ${this.typingUsers[1].username} are typing...`;
        }
        return `${this.typingUsers[0].username} and ${this.typingUsers.length - 1} others are typing...`;
    }
}
